import { useState, useEffect } from 'react'

export const SuccessScreen = () => {
  const [revealProgress, setRevealProgress] = useState(0)

  useEffect(() => {
    const startTime = Date.now()
    const duration = 2500

    const animate = () => {
      const elapsed = Date.now() - startTime
      const progress = Math.min(elapsed / duration, 1)
      setRevealProgress(progress)

      if (progress < 1) requestAnimationFrame(animate)
    }

    requestAnimationFrame(animate)
  }, [])

  return (
    <div
      className="fade-in"
      style={{
        width: '100%',
        height: '100%',
        backgroundColor: '#0F2027',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute', // was fixed
        top: 0,
        left: 0
      }}>
      <div
        style={{
          fontSize: '48px',
          fontWeight: '600',
          color: 'white',
          fontFamily: "'Poppins', 'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
          textAlign: 'center',
          WebkitMaskImage: `linear-gradient(135deg, rgba(0,0,0,1) 0%, rgba(0,0,0,1) ${
            revealProgress * 70
          }%, rgba(0,0,0,0) ${revealProgress * 70 + 20}%, rgba(0,0,0,0) 100%)`,
          maskImage: `linear-gradient(135deg, rgba(0,0,0,1) 0%, rgba(0,0,0,1) ${revealProgress * 70}%, rgba(0,0,0,0) ${
            revealProgress * 70 + 20
          }%, rgba(0,0,0,0) 100%)`,
          WebkitMaskRepeat: 'no-repeat',
          maskRepeat: 'no-repeat',
          WebkitMaskSize: '150% 150%',
          maskSize: '150% 150%',
          WebkitMaskPosition: `${-50 + revealProgress * 100}% ${-50 + revealProgress * 100}%`,
          maskPosition: `${-50 + revealProgress * 100}% ${-50 + revealProgress * 100}%`
        }}>
        Pappnasen Episode 1
      </div>
    </div>
  )
}
